var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenSpinLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88.921,
    height: 11.172,
    viewBox: "0 0 88.921 11.172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_42126",
    "data-name": "Path 42126",
    d: "M5,1504.007c14.283-.349,16.954-5.131,23.124-6.752a17.485,17.485,0,0,1,13.379,1.266c3.669,1.688,2.612,4.615.833,5.486-1.694.848-4.394.1-3.841-2.686.974-4.914,10.627-9.638,24.39-4.066s29.392,2.59,29.392,2.59",
    transform: "translate(-4.232 -1493.954)",
    fill: "none",
    stroke: "#00b248",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenSpinLine);
export default __webpack_public_path__ + "static/media/greenSpinLine.97180bea96327e88958a722176b6a3f3.svg";
export { ForwardRef as ReactComponent };